module.exports = {
  DEFAULT_USER_ROLES: ["pltrackit", "myprefs"],
  COLLECTIONS_SHIPEASE: "shipease",
  DELIVERY_EXCEPTIONS: "exceptions",
  CHANGE_DELIVERY: "change_delivery",
  PLREPORTS: "plreports",
  DISCOLLECT: "discollect",
  EXREPORTS: "exreports",
  PLREVIEWIT_ROLE: "plreviewit",
  COLLECTIONS_SHIPEASE_ROLE: "shipease",
  RFI_ROLE: "rfi",
  IEEXCEPTIONS_ROLE: "ieexceptions",
  TRK_ADMIN_ROLE: "trkadmin",
  RESTRICT_ACTIONS_ROLE: "restrictactions",
};
